import Vue from 'vue'
import axios from 'axios'
import VueRouter from 'vue-router'
import App from './App.vue'
import global from './common.vue'
import { encrypt, decrypt } from './AES/encryp.js';

Vue.use(VueRouter);
Vue.prototype.encrypt = encrypt
Vue.prototype.decrypt = decrypt

// import BookScore from './components/BookScore.vue'
// import BookTree from './components/BookTree.vue'
import HomeBook from './components/HomeBook.vue'
import Home from './components/home.vue'
import ADDFamily from './components/addFamily.vue'
import YiHuan from './components/Yhjm.vue'


Vue.config.productionTip = false

Vue.prototype.COMMON = global
Vue.prototype.axios = axios

//定义路由
const routes = [
  //  {path:'/',component:App},

  { path:'/homeBook', name:'homeBook', component: HomeBook },
  { path:'/gohome', name:'gohome', component: Home },
   {path:'/addFamily', name:'addFamily', component: ADDFamily },
   {path:'/hm', name:'hm', component: YiHuan },

  //  { path:'/bookscore', name:'bookscore', component: BookScore },
  //  { path:'/booktree',  name:'booktree',component: BookTree },
  
   {path:'*',redirect:'/homeBook'},
]

 //创建 router 实例，然后传 routes 配置
const router=new VueRouter({
  routes
  });

new Vue({
  el:"#app",
  router,
  render: h => h(App),
}); 